export const accordionData = [
  {
    key: 1,
    title: 'pricing:accordionData.questionOne',
    content: `pricing:accordionData.answerOne`,
  },
  {
    key: 2,
    title: 'pricing:accordionData.questionTwo',
    content: `pricing:accordionData.answerTwo`,
  },
  {
    key: 3,
    title: 'pricing:accordionData.questionThree',
    content: `pricing:accordionData.answerThree`,
  },
  {
    key: 4,
    title: 'pricing:accordionData.questionFour',
    content: `pricing:accordionData.answerFour`,
  },
  {
    key: 5,
    title: 'pricing:accordionData.questionFive',
    content: `pricing:accordionData.answerFive`,
  },
];
